import { useTranslation } from "react-i18next";
import { Modal } from "../../common";
import { Button } from "../../App.styles";

const ImageModal = ({ onDismiss, show }) => {
    const { t } = useTranslation();

    return (
        <Modal onDismiss={onDismiss} show={show}>
            <div className="modal-header">
                <h4 className="modal-title" dangerouslySetInnerHTML={{ __html: t(`NPC Image`) }} />
                <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-hidden="true"
                    onClick={onDismiss}
                >
                    ×
                </button>
            </div>
            <div className="modal-body">
                <p dangerouslySetInnerHTML={{
                    __html: t(`The image you give your NPC will be shown as their avatar in the game chat.`)
                }} />
            </div>
            <div className="modal-footer">
                <Button type="button" color="dark" data-dismiss="modal" onClick={onDismiss}>
                    {t(`Close`)}
                </Button>
            </div>
        </Modal>
    )
};

export default ImageModal;
